
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 21A10.5 10.5 0 1121 10.5 10.512 10.512 0 0110.5 21zm0-20a9.5 9.5 0 109.5 9.5A9.511 9.511 0 0010.5 1z"}}),_c('path',{attrs:{"d":"M23.5 24a.5.5 0 01-.354-.147l-5.933-5.933a.5.5 0 01.707-.707l5.933 5.933A.5.5 0 0123.5 24zm-8.991-6.173a1.008 1.008 0 01-1.009-1.005V13a1 1 0 011-1h2a1 1 0 011 1v1.976a1.022 1.022 0 01-.2.612 8.493 8.493 0 01-2.25 2.082 1.006 1.006 0 01-.541.157zM14.5 13v3.822a7.277 7.277 0 002-1.831V13zm-8.007 4.828a1.012 1.012 0 01-.543-.158 8.506 8.506 0 01-2.25-2.078 1.027 1.027 0 01-.2-.613V11a1 1 0 011-1h2a1 1 0 011 1v5.825a1.006 1.006 0 01-1.007 1zM4.5 11v3.976a7.4 7.4 0 001.986 1.847L6.5 11zm6 8a8.285 8.285 0 01-1.146-.081 1 1 0 01-.854-.993V9a1 1 0 011-1h2a1 1 0 011 1v8.923a1 1 0 01-.854.993A8.285 8.285 0 0110.5 19zm-1-10v8.923a6.928 6.928 0 002.008 0L11.5 9z"}})])
          )
        }
      }
    